import { IGenericFetchResult, PRODUCT_API_ROUTES } from '@belong/types';
import { IMobileDataProductsResponse, IMobileProductsResponse, INbnProductsResponse } from '@belong/types/api/products';
import { ProductAvailabilityFilter } from '../../hooks/useMobileProducts';
import { GenericAPI } from '../GenericAPI';

class ProductAPI extends GenericAPI {
  async getMobileProducts(journey?: ProductAvailabilityFilter): Promise<IGenericFetchResult<IMobileProductsResponse>> {
    const params = journey ? { journey } : {};
    return this.get(PRODUCT_API_ROUTES.MOBILE_PRODUCTS, params, {
      includeCredentials: false,
      trackedByAnalytics: true
    });
  }

  async getMobileDataProducts(
    journey?: ProductAvailabilityFilter
  ): Promise<IGenericFetchResult<IMobileDataProductsResponse>> {
    const params = journey ? { journey } : {};
    return this.get(PRODUCT_API_ROUTES.MOBILE_DATA_PRODUCTS, params, {
      includeCredentials: false,
      trackedByAnalytics: true
    });
  }

  async getNbnProducts(): Promise<IGenericFetchResult<INbnProductsResponse>> {
    return this.get(PRODUCT_API_ROUTES.NBN_PRODUCTS, {}, { includeCredentials: false, trackedByAnalytics: true });
  }
}

export default new ProductAPI();
